import { isMenuPageWithheld } from '@/config/fabricaNavigation';
import { menuPaths, type FabricaMenus } from './fabricaMenus';
import { webRolesOf, type BranchOption, type UserAccess } from './userAccess';

export const SCHOOL_SETUP_PATH = '/administrator/school';

/** Use the selected branch's authenticated role and menus, never a role's display name or sample-data code. */
export function maySetupSchool(
  access: UserAccess | null,
  menus: FabricaMenus | null,
  activeRoleCode: string | undefined,
  branch: Pick<BranchOption, 'organizationId' | 'branchId'>,
): boolean {
  if (
    !access ||
    !menus ||
    access.activeOrganization.organizationId !== branch.organizationId ||
    access.branchId !== branch.branchId
  )
    return false;
  const role = webRolesOf(access, menus).find((r) => r.code === activeRoleCode);
  return (
    role?.portal === 'administrator' &&
    !isMenuPageWithheld(menuPaths(menus[role.roleId] ?? []), SCHOOL_SETUP_PATH)
  );
}
